import { DISABLED_OPACITY, PRESSABLE_OPACITY, PRESSABLE_SCALE } from '@unistocks/shared/consts';
import { withFeedback } from '@unistocks/shared/utils/haptics/with-feedback';

export const pressableOpacity = {
  cursor: 'pointer',
  pressStyle: {
    opacity: PRESSABLE_OPACITY
  }
} as const;

export const pressableColor = {
  cursor: 'pointer',
  pressStyle: {
    backgroundColor: '$backgroundPress',
    borderColor: '$borderColorPress'
  }
} as const;

export const hoverStyle = {
  hoverStyle: {
    backgroundColor: '$color3',
    borderColor: '$borderColorHover'
  }
} as const;

export const PressableVariants = {
  pressable: {
    true: pressableOpacity,
    opacity: pressableOpacity,
    color: pressableColor
  } as const,

  hoverable: {
    true: hoverStyle
  },

  withFeedback: {
    true: {
      onPressIn: withFeedback
    }
  } as const,

  withScale: {
    true: {
      pressStyle: {
        scale: PRESSABLE_SCALE
      }
    }
  } as const,

  disabled: {
    true: {
      opacity: DISABLED_OPACITY,
      disabled: true,
      cursor: 'not-allowed',
      'aria-disabled': true,

      '$platform-native': {
        pointerEvents: 'none'
      }
    }
  } as const
};
